/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
'use strict'
import Form from 'react-bootstrap/Form';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect } from 'react';
import { queueCodeProbe, getCodeTemplates } from '../data';

function QueueCodeProbeModal({show, setShow}: {show: boolean, setShow: (show: boolean) => void}) {
    const [ templates, setTemplates ] = useState<any[]>([]);
    const [ code, setCode ] = useState<string>(`// load a template or enter code`);

    function queueProbe() {
        queueCodeProbe(code).then((res) => {
            console.log('Queued code probe, id=', res);
        }).catch((err) => {
            console.error('Error queueing code probe:', err);
            alert(`Error queueing code probe: ${err.message}`);
        });
    }

    useEffect(() => {
        // Load templates from the server or a static file
        async function loadTemplates() {
            try {
                let rc = await getCodeTemplates();
                setTemplates(rc);
            } catch (error) {
                console.error('Error loading templates:', error);
                setTemplates([]); // Fallback to default if loading fails
            }
        }
        loadTemplates();
    }, []);

    return (
        <Modal className="modal-lg" show={show} onHide={() => { setShow(false); }}>
            <Modal.Header closeButton>
                <Modal.Title>Code probe</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                This makes up a server side mjs module (it is written to a file and dynamically imported).

                The only exported API required is an async function called `run`, a template is
                  the default value below. This function will be called with the execution context
                and the probe object. The function must return a boolean indicating if the probe passed.
            <Form>
                <Form.Group className="mb-3">
                    <Form.Control 
                        as="textarea" 
                        value={code}
                        rows={10}
                        style={{ fontFamily: 'monospace' }}
                        onChange={(e) => {
                            setCode(e.target.value);
                        }}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Template</Form.Label>
                    <Form.Select 
                        onChange={(e) => {
                            const selectedTemplate = templates.find(t => t.description === e.target.value);
                            if (selectedTemplate) {
                                setCode(selectedTemplate.template);
                            }
                        }}
                    >
                        <option value="">Select a template</option>
                        {templates.map((template, index) => (
                            <option key={index} value={template.description}>
                                {template.description}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Form>
            </Modal.Body>
            <Modal.Footer>
                  <Button variant="primary" onClick={() => { setShow(false); }}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => { 
                    setShow(false);
                    queueProbe();
                }}>
                    Queue Probe
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default QueueCodeProbeModal;